// extracted by mini-css-extract-plugin
export default {"loader-holder":"circle-loader_loader-holder__LjiRU","circle-loader":"circle-loader_circle-loader__FQXdL","spin-animation":"circle-loader_spin-animation__lbMt4"};